/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

/* eslint-disable jira/import-whitelist */
import { createResourceError } from '@jira/router-resources__utils/src/createResourceError.tsx';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { addSpanToAll } from '@atlaskit/react-ufo/interaction-metrics';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

import { FETCH_SIZE_IN_INITIAL_LOAD } from '@jira/servicedesk__queues-common/src/DefaultColumns.tsx';

import { getFieldTypesEligibleForJsonData } from '@jira/servicedesk__queues-common/src/getFieldTypesEligibleForJsonData.tsx';
import type { IssueListResponse } from '@jira/servicedesk__queues-common/src/IssueListResponse.types.tsx';
import type { RouterDataContext } from '@atlassian/react-resource-router';

const fetchIssueListData = async ({
	match,
	query,
}: RouterDataContext): Promise<IssueListResponse | undefined> => {
	const projectKeyOrId = getProjectKeyId(match, query).projectKey;
	const queueId = (match.params && match.params.queueId) || undefined;
	const category = (match.params && match.params.practiceType) || 'no-category';

	if (!queueId) {
		throw createResourceError({
			component: 'spa.view.routes.servicedesk.queues.fetchIssueListSsrData',
			message: 'QueueId is undefined',
			name: 'ResourceError',
			skipSentry: false,
		});
	}

	const bodyWithCategory = {
		columnTypesAsJson: getFieldTypesEligibleForJsonData(),
		issuesPerPage: FETCH_SIZE_IN_INITIAL_LOAD,
		category,
	};
	const url = `/rest/servicedesk/1/servicedesk/${projectKeyOrId}/issuelist/ssr/${queueId}/jis?operation=fetchIssueListSsr`;

	const fetchStartTime = performance.now();

	const data: IssueListResponse = await performPostRequest(url, {
		body: JSON.stringify(bodyWithCategory),
	}).catch(() => undefined);

	addSpanToAll(
		'fetch',
		'/rest/servicedesk/1/servicedesk/projectKey/issuelist/ssr/queueId/jis',
		[{ name: 'network' }],
		fetchStartTime,
		performance.now(),
	);

	return data;
};

export default fetchIssueListData;
